import React from 'react';

import { TableView as TableViewIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { EmployersDetailsWalletCVStaff } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useEmployerParamId } from 'src/hooks/employer';
import { useModalV2 } from 'src/hooks/shared';
import { RevenueShareReportGeneratingModal } from 'src/modals/billing';

export const EmployerDetailBillingPageCVStaff: React.FC = () => {
  const employerId = useEmployerParamId();
  const { openModal } = useModalV2();

  const handleRevenueShareReportClick = React.useCallback(() => {
    openModal(RevenueShareReportGeneratingModal, {
      id: ModalId.RevenueShareReportGenerating,
      companyId: employerId,
      companyType: CompanyType.Employer,
    });
  }, [employerId, openModal]);

  return (
    <DetailPageLayout
      titleContent="Billing"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          onClick={handleRevenueShareReportClick}
          startIcon={<TableViewIcon />}
        >
          Generate report
        </Button>
      }
    >
      <EmployersDetailsWalletCVStaff />
    </DetailPageLayout>
  );
};
